import { TThunkAction } from '../../../../common/types/thunk';

import { setRecommendedPackageCheckoutFillBalance } from '../../../actions/recommendedPackages';
import { loadPublishTerms } from '../../publishTerms/loadPublishTerms';
import { openTopUpBalance } from '../../../actions/webview';
import { IBuyPackageResult } from './types';

export const afterPurchasingPackageThunk =
  (result: IBuyPackageResult): TThunkAction<Promise<void>> =>
  async (dispatch, _, { webview }) => {
    const { isSuccess, amount } = result;

    if (!isSuccess && amount) {
      webview.sendAction(openTopUpBalance(amount));
      dispatch(setRecommendedPackageCheckoutFillBalance(true));

      return;
    }

    if (isSuccess) {
      dispatch(loadPublishTerms());
    }

    dispatch(setRecommendedPackageCheckoutFillBalance(false));
  };
